import React from 'react';
import SafeImage from '../SafeImage';
import { getEventImageSrc, DEFAULT_EVENT_IMAGE } from '../../lib/defaultBranding';

/**
 * EventHero — pure presentational hero banner for the public Event page.
 * Renders the event flyer (via SafeImage) + title overlay. If the host has
 * not uploaded an event image, the VelvetGate platform default is shown
 * instead of a blank area.
 */
export default function EventHero({ event }) {
  const src = getEventImageSrc(event);
  const isDefault = src === DEFAULT_EVENT_IMAGE;
  return (
    <div className="relative h-64 md:h-96 overflow-hidden">
      <SafeImage
        src={src}
        alt={isDefault ? 'VelvetGate' : event.title}
        className="w-full h-full"
        imgClassName="object-cover"
        fallbackLabel={event.title?.slice(0, 2)?.toUpperCase() || 'EVENT'}
        fallbackClassName="w-full h-full"
        data-testid={isDefault ? 'event-hero-default-image' : 'event-hero-image'}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/60 to-transparent"></div>
      <div className="absolute bottom-0 left-0 right-0 p-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-black text-[#EAE7E1] tracking-tighter leading-none" data-testid="event-title">{event.title}</h1>
        </div>
      </div>
    </div>
  );
}
